import * as React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import AuthenticationRequired from 'src/AuthenticationRequired';
import {ThemeProvider} from 'src/hooks/useTheme';
import MainPane from 'src/MainPane';
import {ModalsProvider} from 'src/Modals';
const App = () => {
  return (
    <AuthenticationRequired>
      <div style={{display: 'flex', flexDirection: 'row', height: '100dvh'}}>
        <Router>
          <ThemeProvider>
            <ModalsProvider>
              <MainPane />
            </ModalsProvider>
          </ThemeProvider>
        </Router>
      </div>
    </AuthenticationRequired>
  );
};

export default App;
